import { useContext } from 'react';
import { FormContext } from '../components';
import { devError, isValid } from '@ecom-zform/shared';
/**
 * 获取 FormContext 中的 form
 */
export var useContextForm = function () {
    var context = useContext(FormContext);
    var form = context === null || context === void 0 ? void 0 : context.form;
    devError(isValid(form), 'useContextForm', '上下文中不存在 FormContext');
    return form;
};
